import Hero from './Hero';
import Modes from './Modes';
import HowItWorks from './HowItWorks';
import AssignmentFlow from './AssignmentFlow';
import Safety from './Safety';
import Travellers from './Travellers';
import FAQ from './FAQ';
import { CTA } from './Footer';
import { Page } from './PublicLayout';

export default function LandingPage() {
  return (
    <Page>
      <Hero />
      <Modes />
      <HowItWorks />
      <AssignmentFlow />
      <Safety />
      <Travellers />
      <FAQ />
      <CTA />
    </Page>
  );
}
